import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { AccountService } from './account/account.service';
import { PageRoutes } from './app-routing.module';
import { Router,NavigationEnd  } from '@angular/router';
import { StorageService } from './core-services/storage.service';
import { AuthService } from './core-services/auth.service';
import { DatabaseService } from './core-services/database.service';
import { ObservableService } from './core-services/observable.service';
import { CoreService } from './core-services/core.service';
import { getCtx, setCtx, withCtx } from '../core/context';
import { Subject } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { ShowOptions, SplashScreen } from '@capacitor/splash-screen';
import { ClientService } from './client/client.service';
import { AppointmentService } from './appointment/appointment.service';
import lottie, { AnimationItem } from 'lottie-web';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionService } from './subscription/subscription.service';
import { environment } from '../environments/environment';
import { Meta } from '@angular/platform-browser';
import { FeedService } from './feed/feed.service';
import { OnboardingService } from './core-services/onboarding.service';
import { CalendarIntegrationService } from './core-services/calendar-integration.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public appPages = [
    { title: 'DASHBOARD.title', url: `/${PageRoutes.DASHBOARD}`, icon: 'mail' },
    { title: 'CLIENT.plural', url: `/${PageRoutes.CLIENTS}`, icon: 'paper-plane' },
    { title: 'AGENDA.title', url: `/${PageRoutes.AGENDA}`, icon: 'heart' },
    { title: 'REPORT.title', url: `/${PageRoutes.REPORTS}`, icon: 'archive' },
    // { title: 'SETTINGS.title', url: `/${PageRoutes.SETTINGS}`, icon: 'trash' },
    { title: 'MORE.logout', url: '/folder/spam', icon: 'warning' },
  ];

  public get account() {
    return this.accountService.account;
  }

  public currentRoute: string = PageRoutes.DASHBOARD;
  private platformReady = new Subject<void>();
  platformReady$ = this.platformReady.asObservable();

  static instance: AppComponent;

  private _isReady: boolean;
  public get isReady(): boolean {
    return this._isReady;
  }

  public get isLoading() {
    return this.database.isLoading || this.auth.isLoading || this.core.isLoading;
  }

  private animation: AnimationItem;
  private domElement: HTMLElement;

  constructor(
    public accountService: AccountService,
    private router: Router,
    private storageService: StorageService,
    // private accountService: AccountService,
    private auth: AuthService,
    public database: DatabaseService,
    private observableService: ObservableService,
    private core: CoreService,
    // private clientService: ClientService,
    // private appointmentService: AppointmentService,
    private elementRef: ElementRef,
    private translate: TranslateService,
    private meta: Meta,
    private calendarIntegrationService: CalendarIntegrationService,
    ){
      
      router.events
            .subscribe(event => 
             {
                if (event instanceof NavigationEnd ) {
                  this.currentRoute = event.url;          
                }
             });

      AppComponent.instance = this;

  }

  public async ngOnInit() {
    this.domElement = this.elementRef.nativeElement.querySelector('#splashscreen');

    this.animation = lottie.loadAnimation({
      container: this.elementRef.nativeElement.querySelector('#splashscreenContent'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/splash.json'
    })

    if (environment.allowIndexing) {
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    } else {
      this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    }

    this.meta.updateTag({ property: 'og:title', content: await this.translate.get("APP_NAME").toPromise() });
    this.meta.updateTag({ property: 'og:description', content: await this.translate.get("APP_DESCRIPTION").toPromise() });

    this.init();
  }
  public async init() {
    // this.translateService.setDefaultLang('en');
    console.log("*** APP - Services Starting");
    const subscription = this.auth.onAuthStateChanged$.subscribe(async () => {
      if (this.auth.isLogged) {
        console.log("*** APP - User Logged In");
        // this.router.navigate(['/']);
      } else {
        this.closeSplashScreen();
      }
      subscription.unsubscribe();
    });
    // this.translateService.get("INVOICES").subscribe((v) => console.log("==>>", v))


    try {
      // await this.showSplashScreen({
      //   autoHide: false
      // })
      await this.storageService.init();
      await this.database.init();
      // this.accountService.preInit();
      await this.auth.init();
      await withCtx({ version: null as any }, async (ctx) => {
        console.log("initializing accountService")

        this.storageService.setVersion();
        ctx = getCtx();
        ctx.version = this.storageService.version;
        setCtx(ctx);
        await this.calendarIntegrationService.init();
        // await this.clientService.init();
        // await this.appointmentService.init();
        // await this.feedService.init();
        this.closeSplashScreen();
        // animation.stop();
      });
      this._isReady = true;
      this.observableService.publishPlatformReady();
      // analytics
    } catch(e) {
      console.log(e)
      this.closeSplashScreen();
    }
  }



  public async closeSplashScreen() {
    if (Capacitor.isPluginAvailable("SplashScreen")) {
      await SplashScreen.hide();
    }
    this.animation.stop();
    this.domElement.style.display = 'none';
  }

  public async showSplashScreen(options?: ShowOptions) {
    // if (Capacitor.isPluginAvailable("SplashScreen")) {
    //   await SplashScreen.show(options);
    // }
  }  
  public close() {
    this.auth.isLoginModalOpen = false;
  }

  public login() {
    this.auth.showLoginModal()
  }   
}
